export default __webpack_public_path__ + "static/media/step01.5cace39f.png";